import { TApplicationState } from '../../types/redux';

export function getIsFlatTourAvailable(state: TApplicationState): boolean {
  return Boolean(state.flatTourBookingState.flatTourBooking);
}
